import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api_getCategoryByCode } from '~/backend/api_calls';
import Button from '~/components/common/Button';
import { FiltersBannerLoader } from '~/components/common/SkeletonLoaders';
import HomepageFiltersModal from './HomepageFiltersModal';

// DEMO IMPORT FOR NOW START
// DEMO IMPORT FOR NOW END

const FiltersBanner = () => {
	const featuredCategoriesCodes = ['MAN', 'WOMAN', 'INFANT'];

	const { t } = useTranslation();

	const [loading, setLoading] = useState(false);
	const [featuredCategories, setFeaturedCategories] = useState([]);
	const [filterModalVisible, setFilterModalVisible] = useState(false);
	const [selectedCategory, setSelectedCategory] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			const categoriesPromises = featuredCategoriesCodes.map(code =>
				api_getCategoryByCode(code)
					.then(json => {
						return json;
					})
					.catch(error => {
						console.log(error);
					})
			);

			await Promise.all(categoriesPromises).then(data => {
				setFeaturedCategories(data);
				setLoading(false);
			});
		};

		fetchData();
	}, []);

	const handleOpenFiltersModal = category => {
		setSelectedCategory(category);
		setFilterModalVisible(true);
	};

	return (
		<>
			<div className="filters-banner">
				<div className="content-wrapper">
					{loading ? (
						<FiltersBannerLoader />
					) : (
						<div className="filters-banner-container">
							{featuredCategories.map(
								(category, index) =>
									category?.id && (
										<div key={index} className="category">
											<h2>{category.nm}</h2>
											<div className="category-img">
												<img src={category.img1 ?? category.img2} alt={''} loading="lazy" width="376px" height="306px" />
												<div className="overflow-button">
													<Button color="secondary" outline={true} actionOnClick={() => handleOpenFiltersModal(category)}>
														{t('apply_filters')}
													</Button>
												</div>
											</div>
										</div>
									)
							)}
						</div>
					)}
				</div>
			</div>

			{filterModalVisible && (
				<HomepageFiltersModal
					filterModalVisible={filterModalVisible}
					setFilterModalVisible={setFilterModalVisible}
					category={selectedCategory}
				/>
			)}
		</>
	);
};

export default FiltersBanner;
